export class SamlIdentityProvider {
    'id';
    'providerName';
    'ssoUrl';
    'logoutUrl';
    'issuerUrl';
    'certificate';
    'enableAuthenticationRequestSigning';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerName",
            "baseName": "providerName",
            "type": "string",
            "format": ""
        },
        {
            "name": "ssoUrl",
            "baseName": "ssoUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "logoutUrl",
            "baseName": "logoutUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "issuerUrl",
            "baseName": "issuerUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "certificate",
            "baseName": "certificate",
            "type": "string",
            "format": ""
        },
        {
            "name": "enableAuthenticationRequestSigning",
            "baseName": "enableAuthenticationRequestSigning",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SamlIdentityProvider.attributeTypeMap;
    }
    constructor() {
    }
}
